import React from 'react'
import { Icon } from 'semantic-ui-react'

import { numberFormat } from 'core/utilities'
import { DivText } from 'components'

export const columnLimitOfBank = [
  {
    Header: 'Active',
    accessor: 'active',
    width: 70,
    Cell: row => (<DivText><Icon name={row.value?'check circle':'times circle'} color={row.value?'green':'gray'}/></DivText>)
  }, 
  {
    Header: 'Action',
    accessor: 'action',
    width: 70,
    Cell: row => (<DivText><Icon name='edit'/></DivText>)
  },
  {
    Header: 'Company',
    accessor: 'companyName',
  }, 
  {
    Header: 'Bank',
    accessor: 'bankName',
  }, 
  {
    Header: 'Limit(THB)',
    accessor: 'limit',
    width: 130,
    className: 'center',
    Cell: row => numberFormat(row.value)
  }, 
  {
    Header: 'Usage(THB)',
    accessor : 'usage',
    width: 130,
    className: 'center',
    Cell: row => numberFormat(row.value)
  },
  {
    Header: 'Balance(THB)',
    accessor: 'balance',
    width: 130,
    className: 'center',
    Cell: row => numberFormat(row.value,true)
  }, 
  {
    Header: 'Lower 5% (BL)',
    accessor : row =>(!row.alert?0:!row.lower?1:2), //0:alert==false, 1:lower==false, 2:lower==true
    id:'alert',
    width: 120,
    Cell: row => (<DivText><Icon name={row.value==0?'times circle':'check circle'} color={row.value==0?'gray':row.value==1?'green':'red'}/></DivText>)
  }, 
]

export const exportColumn = [
  { key: 'companyName', label: 'Company' },
  { key: 'bankName', label: 'Bank' },
  { key: 'limit', label: 'Limit(THB)' },
  { key: 'balance', label: 'Balance(THB)' },
  { key: 'usage', label: 'Usage(THB)' },
]